<template>
    <div>
        <van-calendar v-if="calendarMinDate != null && calendarMaxDate != null" v-model="calendarShow"
            first-day-of-week="1" title="我的档案" :min-date="calendarMinDate" :max-date="calendarMaxDate"
            @confirm="onConfirm" @month-show="calendarMonthShow" :show-confirm="false" :show-subtitle="false"
            :formatter="formatter" :default-date="defaultDate" color="rgba(111,143,234,.5)">
            <!-- <template #title>
                <span>自定义标题</span>
            </template>
<template #footer>
                <span>自定义底部</span>
            </template> -->
            <template #top-info="day">
                <van-icon name="good-job" color="#6F8FEA" v-if="day.count" />
            </template>
            <template #bottom-info="day">
                <span style="color: #6F8FEA;" v-if="day.count">检测{{ day.count }}次</span>
            </template>
        </van-calendar>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { businessGet } from '../api/business.js'
import { utilsListQuery } from '../utils/utils.js'
export default {
    name: "publicCalendar",
    data() {
        return {
            calendarShow: false,
            minDaysNum: this.queryDays,
            nowMinDaysNum: 0,
            calendarMinDate: null,
            calendarMaxDate: null,
            detectionList: [
                // {
                //     date: '2025-02-01',
                //     count: 3,
                // }
            ],
            defaultDate: new Date(),
        }
    },
    props: {
        initShow: Object,
        queryDays: {
            type: Number,
            default: 590
        }
    },
    watch: {
        initShow: {
            handler(val) {
                if (val) {
                    this.calendarShow = val.show;
                    if (val.defaultDate) {
                        this.defaultDate = val.defaultDate;
                        setTimeout(() => {
                            let dom = document.querySelector('.van-calendar__body');
                            let nowScrollTop = dom.scrollTop;
                            dom.scrollTop = nowScrollTop - 1;
                        }, 100)
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.nowMinDaysNum += this.minDaysNum;
        this.calendarMinDate = dayjs().subtract(this.nowMinDaysNum, 'day').toDate();
        this.calendarMaxDate = dayjs().toDate();
        // this.calendarMinDate = dayjs().startOf('month').toDate();
        // this.calendarMaxDate = dayjs().endOf('month').toDate();
        this.getDetectionList();
    },
    methods: {
        getDetectionList() {
            let startDate = dayjs(this.calendarMinDate).format('YYYY-MM-DD') + ' 00:00:00';
            let endDate = dayjs(this.calendarMaxDate).format('YYYY-MM-DD') + ' 23:59:59';
            let url = '/system/task/getTaskDate?startDate=' + startDate + '&endDate=' + endDate;
            businessGet(url).then(res => {
                if (res.code == 200) {
                    this.detectionList = res.data;
                }
            })
        },
        formatter(day) {
            let time = dayjs(day.date).format('YYYY-MM-DD');
            let searchMsg = utilsListQuery(this.detectionList, time, 'date');
            if (searchMsg) {
                day.count = searchMsg.count;
            }
            day.className = 'unique-custom-date-style';
            return day;
        },
        calendarMonthShow(val) {
            // console.log(val)
            let isSameYearAndMonth = dayjs(val.date).isSame(this.calendarMinDate, 'month');
            // console.log('经过的月份', dayjs(val.date).format('YYYY-MM'), '最小月份', dayjs(this.calendarMinDate).format('YYYY-MM'), '是否同月', isSameYearAndMonth)
            if (isSameYearAndMonth) {
                this.nowMinDaysNum += this.minDaysNum;
                this.calendarMinDate = dayjs().subtract(this.nowMinDaysNum, 'day').toDate();
                this.getDetectionList();
            }
        },
        onConfirm(date) {
            this.calendarShow = false;
            this.$emit('onConfirm', date)
        },
    }
}
</script>

<style scoped></style>